import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import './Summary.scss';

const SummaryCovered = props => {
  const { covered, strings } = props;
  if (Array.isArray(covered))
    return (
      <Fragment key="covered-summary">
        {covered.map((c, k) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={k} className="row">
            {c.party ? (
              <>
                <span className="header">#{k + 1}</span>
                {c.party.first_name ? (
                  <>
                    <span className="label">{strings['block.covered.party.field.first_name.label']}</span>
                    <span className="item">{c.party.first_name}</span>
                  </>
                ) : undefined}
                {c.party.first_name ? (
                  <>
                    <span className="label">{strings['block.covered.party.field.name.label']}</span>
                    <span className="item">{c.party.name}</span>
                  </>
                ) : undefined}
                {c.party.share ? (
                  <>
                    <span className="label">{strings['block.covered.field.share.label']}</span>
                    <span className="item">{c.share}%</span>
                  </>
                ) : undefined}
              </>
            ) : undefined}
          </div>
        ))}
      </Fragment>
    );
  return undefined;
};

SummaryCovered.propTypes = {
  covered: PropTypes.any.isRequired, // eslint-disable-line
  strings: PropTypes.any.isRequired, // eslint-disable-line
};

SummaryCovered.defaultProps = {};

export default SummaryCovered;
